module.exports = __webpack_public_path__ + "static/media/imageMoss.5b318cbb.webp";